import { Component, inject, Input } from '@angular/core';
import { UiText } from '@ory/client';
import { ToastController } from '@ionic/angular/standalone';

@Component({
  selector: 'iam-messages',
  template: ``,
})
export class IamMessagesComponent {
  @Input({
    required: true,
    alias: 'messages',
  })
  set _messages(messages: UiText[]) {
    const messageList = (messages || []).map((message) => ({
      detail: message.text,
      severity: message.type,
    }));
    if (!messageList.length) return;
    this.presentToast(messageList[0]);
  }

  toastController = inject(ToastController);

  private async presentToast(message) {
    const toast = await this.toastController.create({
      message: message.detail,
      duration: 2500,
      position: 'bottom',
      color: this.mapTypeToColor(message.severity),
      buttons: [{ text: 'OK' }],
    });

    await toast.present();
  }

  private mapTypeToColor(type: string) {
    switch (type) {
      case 'success':
        return 'success';
      case 'error':
        return 'danger';
      case 'warn':
        return 'warning';
      default:
        return 'primary';
    }
  }
}
